// extracted by mini-css-extract-plugin
export default {"container":"styles_container__p837y","header":"styles_header__mQrve","action":"styles_action__yykFM"};